<template>
  <div class="private-chat" @click="closeDeleteMsgPopup">
    <div class="private-header">
      <div class="a" @click="back">
        <img src="./img/back-arrow.png" alt="" />
        <div>{{ $t("chat.back") }}</div>
      </div>
      <div class="c text-overflow">
        {{ groupInfo.name }}({{ groupInfo.user_num }})
      </div>
      <div class="d">
        <img @click="toGroupInfo" src="./img/setting.png" alt="" />
      </div>
    </div>
    <div class="private-content" ref="privateChat" @scroll="onscroll">
      <img
        v-show="isLoadingMore"
        src="@/assets/img/loading-1.gif"
        alt=""
        style="display: block; margin: 0 auto"
      />
      <div :style="{ height: addHeightForBanned }"></div>
      <div
        class="message-list"
        v-for="(item, index) in groupMessageList"
        :key="index"
        ref="avatar"
      >
        <div class="chat-time" v-show="item.chatType === 3">
          {{ item.content }}
        </div>
        <div
          class="chat-anchor"
          v-show="
            item.chatType === 2 &&
            (item.content || item.image_url) &&
            item.type !== 2
          "
        >
          <div class="avatar">
            <img
              @click.stop="openBannedUserPopup(item, index)"
              :src="
                item.avatar
                  ? item.avatar
                  : require('@/assets/img/default/default_logo1.png')
              "
              alt=""
            />
            <div class="popup-banned" v-show="bannedUser === item.send_time">
              <div class="banned" @click.stop="toUserChat(item)">
                {{ $t("pcLive.privateChat") }}
              </div>
              <div class="bar"></div>
              <div class="banned" @click.stop="openConfirmBannedPopup(item)">
                {{ $t("chat.block") }}
              </div>
              <div class="bar"></div>
              <div
                class="kickout"
                @click.stop="openConfirmKickoutPopup(kickoutDialog)"
              >
                {{ $t("chat.notAllowed") }}
              </div>
            </div>
            <div class="popup-banned" v-show="unbannedUser === item.send_time">
              <div
                class="banned"
                @click.stop="openConfirmUnbannedPopup(unbannedDialog)"
              >
                {{ $t("live.unbannedUser") }}
              </div>
              <div class="bar"></div>
              <div
                class="kickout"
                @click.stop="openConfirmKickoutPopup(kickoutDialog)"
              >
                {{ $t("chat.notAllowed") }}
              </div>
            </div>
          </div>
          <div class="msg" @click.stop="openDeleteMsgPopup(index)">
            <div
              class="popup"
              @click.stop="openConfirmDeleteMsgPopup(deleteMsgDialog, item)"
              v-show="deleteMsgId === index"
            >
              {{ $t("img.delete") }}
            </div>
            <img class="angle" src="./img/angle-left.png" alt="" />
            <div class="nickname">
              <div>{{ item.nick_name }}</div>
              <div class="role" v-show="item.role === 1">
                {{ $t("chat.roomManage") }}
              </div>
              <div class="role role1" v-show="item.role === 2">
                {{ $t("chat.owner") }}
              </div>
            </div>
            <div class="text">{{ item.content }}</div>
            <el-image
              v-show="item.image_url"
              :src="item.image_url"
              @load="loadImage"
              :preview-src-list="[item.image_url]"
            >
            </el-image>
          </div>
        </div>
        <div
          class="chat-user"
          v-show="
            item.chatType === 1 &&
            (item.content || item.image_url) &&
            item.type !== 2
          "
        >
          <div class="msg" @click.stop="openWithdraw(item)">
            <div
              class="withdraw"
              @click.stop="openConfirmWithdrawPopup(withdrawDialog, item)"
              v-show="withdrawMsgId === item.send_time"
            >
              {{ $t("chat.remove") }}
            </div>
            <div
              class="red-dot"
              v-show="errorMessageIds.indexOf(item.send_time) > -1"
              @click="showErrorMsg"
            >
              !
            </div>
            <img class="angle" src="./img/angle-right.png" alt="" />
            <div class="text">{{ item.content }}</div>
            <el-image
              v-show="item.image_url"
              :src="item.image_url"
              @load="loadImage"
              :preview-src-list="[item.image_url]"
            >
            </el-image>
          </div>
          <img
            class="avatar"
            :src="
              userInfo.avatar
                ? userInfo.avatar
                : require('@/assets/img/default/default_logo1.png')
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="to_bottom_btn" @click="toBottom" v-if="showMoreMsg">
      {{ $t("chat.thereIsNew") }}
    </div>
    <div class="message_bottom">
      <div class="icon_btn">
        <emoji-picker @emoji="insert">
          <div
            slot="emoji-invoker"
            slot-scope="{ events: { click: clickEvent } }"
            @click.stop="clickEvent"
          >
            <img class="icon-img" src="./img/emoji.png" title="表情" />
          </div>
          <div
            class="emoji"
            slot="emoji-picker"
            slot-scope="{ emojis, insert }"
          >
            <div class="emoji-cats">
              <div
                class="emoji-cat"
                :class="emojiCategory == index ? 'emoji-active' : ''"
                @click="changeEmojiCategory(index)"
                v-for="(item, index) in emojiCates"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div
              v-for="(emojiGroup, category, index) in emojis"
              :key="category"
            >
              <div class="emoji-item" v-if="emojiCategory == index">
                <span
                  v-for="(emoji, emojiName) in emojiGroup"
                  :key="emojiName"
                  @click="insert(emoji)"
                  :title="emojiName"
                  >{{ emoji }}</span
                >
              </div>
            </div>
          </div>
        </emoji-picker>
        <el-upload
          :multiple="false"
          :before-upload="beforeUpload"
          :http-request="handleUpload"
          class="upload-demo"
          :show-file-list="false"
          :auto-upload="true"
          :action="'/asd'"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          v-loading="isUpLoading"
        >
          <img
            class="icon-img"
            style="width: 0.25rem; height: 0.25rem"
            src="./img/picture.png"
            alt
          />
        </el-upload>
      </div>
      <div class="sent_content">
        <div class="input_content">
          <input
            type="text"
            class="login_input"
            required="required"
            @input="formatMessage"
            v-model="messageContent"
            @keyup.enter="sendMsg()"
          />
        </div>
        <div class="input_send" @click.stop="sendMsg">
          {{ $t("chat.sendText") }}
        </div>
      </div>
    </div>
    <ConfirmDialog
      :content="content"
      @confirmDialog="confirmDialog"
      ref="confirmDialog"
    />
    <BannedDialog :bannedUserVal="bannedUserVal" ref="bannedDialog" />
    <SendPicture
      :sendPicture="sendPicture"
      :isLoadingPic="isLoadingPic"
      @clearPicture="clearPicture"
      @confirmDialog="confirmDialog"
      ref="sendPicture"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import { EmojiPicker } from "vue-emoji-picker";
import TIM from "tim-js-sdk";
import { tim } from "@/util/tim";
import { format } from "@/util/time";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
import BannedDialog from "@/components/dialog/BannedDialog";
import SendPicture from "@/components/dialog/SendPicture";
import uploadByCosSdk from "@/mixins/uploadByCosSdk";

export default {
  mixins: [uploadByCosSdk],
  components: { EmojiPicker, ConfirmDialog, BannedDialog, SendPicture },
  computed: {
    ...mapState([
      "userInfo",
      "appConfig",
      "groupMessageList",
      "groupInfo",
      "loginRepData",
      "fanGroup",
      "noMoreMsg",
      "isLoadingMore",
    ]),
    roomId() {
      return this.liveDetail.anchorid || 0;
    },
  },
  props: {
    liveDetail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    groupMessageList(newVal) {
      let lastArray = newVal[newVal.length - 1] || {};
      if (!this.isBottom) {
        this.showMoreMsg = true;
      }
      if (this.isBottom) {
        console.log("toBottom");
        this.toBottom();
      }
    },
  },

  data() {
    return {
      emojiCates: [
        this.$t("emoji.recently"),
        this.$t("emoji.smile"),
        this.$t("emoji.anima"),
        this.$t("emojiPicker.project"),
      ],
      messageContent: "",
      emojiCategory: 0,
      errorMessageIds: [],
      errorMsg: "",
      deleteMsgId: 0,
      content: "",
      kickoutDialog: [this.$t("chat.blockConfirm")],
      unbannedDialog: [this.$t("chat.unBlockConfirm")],
      deleteMsgDialog: [this.$t("chat.deleteConfirm")],
      withdrawDialog: [this.$t("chat.removeConfirm")],
      bannedUser: 0,
      bannedUserVal: {},
      unbannedUser: 0,
      withdrawMsgId: 0,
      showMoreMsg: false,
      isBottom: true,
      addHeightForBanned: 0,
      isUpLoading: false,
      sendPicture: "",
      page: 1,
      isLoadingPic: false,
    };
  },
  created() {},
  destroyed() {
    this.readGroupChat(this.fanGroup.fans_group_id);
    this.changeGroupMessageList([]);
  },
  mounted() {
    this.getGroupInfo();
    this.getGroupHistory();
    this.changeNoMoreMsg(false);
  },
  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleLogin",
      "pushToast",
      "changeGroupMessageList",
      "changeNoMoreMsg",
    ]),
    ...mapActions(["getGroupInfo", "getGroupHistory", "readGroupChat"]),
    loadImage() {
      if (this.isBottom) {
        this.toBottom();
      }
    },
    clearPicture() {
      console.log(this.sendPicture, "clearPicture");
      this.sendPicture = "";
    },
    handleUpload(res) {
      const file = res.file;
      this.$refs.sendPicture.open();
      this.isLoadingPic = true;
      this.upload(file)
        .then((res) => {
          if (res.status === 0) {
            console.log("handleUpload", res);
            this.sendPicture = res.data;
            this.isLoadingPic = false;
          }
        })
        .finally((err) => {
          console.log(err);
        });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isJpeg = file.type === "image/jpeg";
      if (!isJPG && !isGIF && !isPNG && !isJpeg) {
        this.$message.error(this.$t("chat.imgFormat"));
        return false;
      }
    },
    toUserChat(item) {
      this.bannedUser = 0;
      this.$emit("toUserChat", item);
    },
    openConfirmWithdrawPopup(val, item) {
      this.content = val;
      this.withdrawMsgId = 0;
      this.bannedUserVal = item;
      this.$refs.confirmDialog.open();
    },
    openWithdraw(item) {
      console.log("openWithdraw", item);
      this.withdrawMsgId = item.send_time;
    },
    openConfirmUnbannedPopup(val) {
      this.content = val;
      this.bannedUser = 0;
      this.$refs.confirmDialog.open();
    },
    openConfirmBannedPopup(val) {
      this.bannedUser = 0;
      this.$refs.bannedDialog.open();
    },
    openConfirmKickoutPopup(val) {
      this.content = val;
      this.bannedUser = 0;
      this.$refs.confirmDialog.open();
    },
    openBannedUserPopup(val, index) {
      let avatarToTop = this.$refs.avatar[index].offsetTop;
      if (avatarToTop < 140) {
        this.addHeightForBanned = (140 - avatarToTop) / 100 + "rem";
      }
      if (val.role === 2) {
        this.$emit("openAnchorInfo", val.uid);
        return;
      }
      if (this.groupInfo.user_info.role === 1 && val.role === 0) {
        console.log("bannedUserVal", val);
        this.bannedUserVal = val;
        this.getBanInfo(val);
      }
    },
    openConfirmDeleteMsgPopup(val, item) {
      if (this.groupInfo.user_info.role > 0) {
        this.bannedUserVal = item;
        console.log(this.bannedUserVal);
        this.content = val;
        this.deleteMsgId = 0;
        this.$refs.confirmDialog.open();
      }
    },
    openDeleteMsgPopup(val) {
      if (this.groupInfo.user_info.role > 0) {
        this.deleteMsgId = val;
      }
    },
    closeDeleteMsgPopup() {
      this.deleteMsgId = 0;
      this.bannedUser = 0;
      this.withdrawMsgId = 0;
      this.unbannedUser = 0;
      this.addHeightForBanned = 0;
    },
    confirmDialog(val) {
      if (val === this.deleteMsgDialog) {
        console.log(val);
        this.delMsg();
      } else if (val === this.unbannedDialog) {
        console.log(val);
        this.cancelBanUser();
      } else if (val === this.withdrawDialog) {
        console.log(val);
        this.revokeMsg();
      } else if (val === this.kickoutDialog) {
        console.log(val);
        this.kickUser();
      } else if (val === this.sendPicture) {
        console.log(val);
        this.sendMsg();
      }
    },
    back() {
      this.$emit("changeGroupChat", false);
    },
    toGroupInfo() {
      this.$emit("toGroupInfo", this.fanGroup);
    },
    changeEmojiCategory(category) {
      this.emojiCategory = category;
    },
    insert(emoji) {
      this.messageContent += emoji;
    },
    withdrawMsg(seq) {
      let arr = this.groupMessageList.filter((e) => e.seq !== seq);
      let notice = {
        chatType: 3,
        content: this.$t("chat.removeInfo"),
      };
      this.changeGroupMessageList([...arr, notice]);
    },
    kickUser() {
      post({
        url: "/api/groupChat/kickUser",
        data: {
          group_id: this.groupInfo.id,
          kick_user_ids: [this.bannedUserVal.uid],
        },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.$message.success(this.$t("chat.blockSuccess"));
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    revokeMsg() {
      if (this.errorMessageIds.indexOf(this.bannedUserVal.send_time) > -1) {
        this.$message.error(this.$t("chat.sendFail"));
        return;
      }
      post({
        url: "/api/groupChat/revokeMsg",
        data: { group_id: this.groupInfo.id, msg_id: this.bannedUserVal.seq },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.withdrawMsg(this.bannedUserVal.seq);
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    delMsg() {
      post({
        url: "/api/groupChat/delMsg",
        data: { group_id: this.groupInfo.id, msg_id: this.bannedUserVal.seq },
      })
        .then(({ data: { msg } }) => {
          console.log(msg);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    cancelBanUser() {
      post({
        url: "/api/groupChat/cancelBanUser",
        data: {
          ban_user_id: this.bannedUserVal.uid,
          fans_group_id: this.bannedUserVal.group_id,
        },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.unbannedUser = 0;
            this.$message.success(this.$t("chat.unBanner"));
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    getBanInfo(user) {
      post({
        url: "/api/groupChat/getBanInfo",
        data: { ban_user_id: user.uid, fans_group_id: user.group_id },
      })
        .then(({ data: { data } }) => {
          console.log(data.is_ban, "data.is_ban");
          this.bannedUserVal.level = data.user_level;
          if (!data.is_ban) {
            this.bannedUser = user.send_time;
          } else {
            this.unbannedUser = user.send_time;
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    formatMessage() {
      if (
        this.messageContent.length > 200 &&
        this.groupInfo.user_info.role !== 1
      ) {
        this.messageContent = this.messageContent.slice(0, 200);
        this.$message.error(this.$t("chat.max"));
      }
    },
    sendMsg() {
      // console.log("url", url);
      if (!this.messageContent.trim() && this.sendPicture === "") {
        this.messageContent = "";
        this.pushToast(this.$t("chat.empty"));
        return;
      }

      // 发送消息
      const msg = {
        type: "say",
        groupId: this.groupInfo.fans_group_id,
        content: window.encrypt(this.messageContent.trim()), //接口提供wasm加密
        image_url: this.sendPicture,
      };

      console.log("groupMessageList:::::::::", this.groupMessageList);
      let nowTime = Date.parse(new Date());
      let lastMsgTime =
        this.groupMessageList[this.groupMessageList.length - 1]?.send_time || 0;
      console.log(nowTime, lastMsgTime, "time");
      //相隔60秒添加时间线
      if (nowTime - lastMsgTime > 60000) {
        this.groupMessageList.push({
          chatType: 3,
          send_time: nowTime,
          content: format(nowTime, "MM-dd hh:mm"),
        });
      }
      this.groupMessageList.push({
        chatType: 1,
        send_time: nowTime,
        content: this.messageContent.trim(),
        image_url: this.sendPicture,
        uid: this.userInfo.id,
      });
      this.timSend(msg, nowTime);
      this.messageContent = "";
      this.sendPicture = "";

      console.log(msg, this.groupMessageList, "msg");
      this.toBottom();
    },
    timSend(msg, nowTime) {
      let msgJson = JSON.stringify(msg);
      let message = tim.createCustomMessage({
        to: this.groupInfo.fans_group_id,
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
          data: msgJson,
        },
      });
      console.log("message=======================", message);
      let msgLength = this.groupMessageList.length;
      let promise = tim.sendMessage(message);
      promise
        .then((imResponse) => {
          // 发送成功
          console.log("发送成功", imResponse);
          this.sendPicture = "";
          this.groupMessageList[msgLength - 1].seq = message.sequence; //临时直接修改vuex
        })
        .catch((imError) => {
          // 发送失败
          this.errorMessageIds.push(nowTime);
          this.errorMsg = imError.message;
          if (imError.code === 10007) {
            this.errorMsg = this.$t("chat.canNotSend");
            this.$message.error(this.$t("chat.canNotSend"));
            return;
          } else if (imError.code === 10017) {
            this.errorMsg = this.$t("chat.bannedDone");
            this.$message.error(this.$t("chat.bannedDone"));
            return;
          } else {
            this.$message.error(imError.message);
          }
        });
    },
    onscroll() {
      // 是否滚动到了底部
      let chatBox = this.$refs.privateChat;
      let clientHeight = chatBox?.clientHeight;
      let scrollTop = chatBox?.scrollTop;
      let scrollHeight = chatBox?.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.showMoreMsg = false;
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
      if (scrollTop === 0) {
        console.log("toTop");
        this.page++;
        if (!this.noMoreMsg) {
          this.getGroupHistory(this.page);
        }
      }
    },
    toBottom() {
      this.$nextTick(() => {
        if (this.$refs["privateChat"]) {
          this.$refs["privateChat"].scrollTop =
            this.$refs["privateChat"].scrollHeight;
        }
      });
    },
    showErrorMsg() {
      this.$message.error(this.errorMsg);
    },
  },
};
</script>

<style scoped lang="scss">
.private-chat {
  // flex: 1;
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  position: relative;
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
  margin-top: 0.12rem;
  margin-right: 0.4rem;
  .private-header {
    height: 0.42rem;
    display: flex;
    align-items: center;
    background: linear-gradient(
        0deg,
        rgba(2, 168, 162, 0.15),
        rgba(2, 168, 162, 0.15)
      ),
      #ffffff;
    .a {
      display: flex;
      width: 0.8rem;
      color: #666666;
      font-size: 0.12rem;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
        margin-left: 0.12rem;
        margin-right: 0.05rem;
      }
    }
    .c {
      flex: 1;
      text-align: center;
      color: #000000;
    }
    .d {
      width: 0.8rem;
      display: flex;
      justify-content: flex-end;
      img {
        width: 0.24rem;
        margin-right: 0.12rem;
        cursor: pointer;
      }
    }
  }
  .private-content {
    flex: 1;
    border-bottom: 1px solid #eee;
    overflow-y: auto;
    position: relative;
    // padding: 0 0.12rem;
    background: #fff;
    /*火狐下隐藏滚动条*/
    scrollbar-width: none;
    padding: 0.08rem 0.12rem;
    color: #333333;
    .chat-time {
      text-align: center;
      margin-bottom: 0.12rem;
      color: #999;
      font-size: 0.12rem;
    }
    .chat-anchor {
      display: flex;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;
      position: relative;
      .avatar {
        position: relative;
        img {
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 0.28rem;
          margin-right: 0.08rem;
          cursor: pointer;
        }
        .popup-banned {
          z-index: 1;
          width: 1rem;
          height: 0.9rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          position: absolute;
          left: 0;
          top: -1.06rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
          .bar {
            width: 0.8rem;
            height: 0.5px;
            background: #f4f4f4;
          }
          .kickout {
            cursor: pointer;
          }
          .banned {
            cursor: pointer;
          }
        }
      }
      .msg {
        max-width: 2.34rem;
        padding: 0.05rem 0.12rem;
        background: #f4f4f4;
        border-radius: 0.1rem 0.1rem 0.1rem 0px;
        position: relative;
        cursor: pointer;
        .popup {
          width: 0.48rem;
          height: 0.44rem;
          line-height: 0.44rem;
          text-align: center;
          position: absolute;
          left: 0;
          top: -0.53rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
        }

        .nickname {
          color: #8393bc;
          display: flex;
          align-items: center;
          .role {
            width: 0.39rem;
            height: 0.2rem;
            line-height: 0.17rem;
            text-align: center;
            background: rgba(2, 161, 249, 0.2);
            border: 1px solid rgba(60, 156, 254, 0.5);
            border-radius: 0.02rem;
            color: #02a1f9;
            font-size: 0.12rem;
            transform: scale(0.83);
          }
          .role1 {
            background: rgba(2, 168, 162, 0.2);
            border: 1px solid rgba(2, 168, 162, 0.5);
            color: #02a8a2;
          }
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          left: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-word;
          white-space: pre-wrap;
          cursor: pointer;
        }
      }
    }
    .chat-user {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;

      .msg {
        max-width: 2.34rem;
        padding: 0.05rem 0.12rem;
        background: rgba(2, 168, 162, 0.2);
        border-radius: 0.1rem 0.1rem 0px 0.1rem;
        position: relative;
        cursor: pointer;
        .withdraw {
          width: 0.48rem;
          height: 0.44rem;
          line-height: 0.44rem;
          text-align: center;
          position: absolute;
          right: 0;
          top: -0.53rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
        }
        .red-dot {
          position: absolute;
          top: 0.08rem;
          left: -0.2rem;
          background: #db6372;
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 0.16rem;
          line-height: 0.16rem;
          text-align: center;
          color: #ffffff;
          margin-right: 0.04rem;
          cursor: pointer;
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          right: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-word;
          white-space: pre-wrap;
        }
      }
      .avatar {
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 0.28rem;
        margin-left: 0.08rem;
      }
    }
  }
  .to_bottom_btn {
    width: 3.4rem;
    height: 0.3rem;
    background: rgba(2, 168, 162, 0.7);
    text-align: center;
    line-height: 0.3rem;
    color: #fff;
    font-size: 0.12rem;
    // position: absolute;
    // top: -0.3rem;
    // left: 50%;
    // transform: translateX(-50%);
    position: relative;
    cursor: pointer;

    &::before {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      // top: 60%;
      bottom: 0;
      left: 32%;
      transform: translateY(-50%);
      border: 0.05rem solid transparent;
      border-top: 0.05rem solid #fff;
    }
  }
  .message_bottom {
    position: relative;
    // height: 1.08rem;
    height: 1rem;
    padding: 0 0.16rem;
    background: #ffffff;
    .icon_btn {
      display: flex;
      align-items: center;
      height: 0.4rem;
      .icon-img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.1rem;
        cursor: pointer;
      }
    }
    .emoji {
      width: 3.39rem;
      position: absolute;
      top: -1.6rem;
      left: 0;
      background-color: #fff;
      border-top: 0.01rem solid #eee;
    }
    .emoji-cats {
      display: flex;
      .emoji-cat {
        width: 0.85rem;
        height: 0.3rem;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .emoji-active {
        background-color: #fff;
      }
    }
    .emoji-item {
      height: 1.3rem;
      padding: 0.1rem;
      overflow: scroll;
      span {
        margin: 0.03rem;
        margin-bottom: 0.05rem;
        display: inline-block;
        cursor: pointer;
      }
    }

    .sent_content {
      width: 100%;
      display: flex;

      .input_content {
        flex: 1;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 4px 0 0 4px;
        height: 0.48rem;
        font-size: 0.12rem;
        display: flex;
        justify-content: space-between;

        .login_input {
          width: 100%;
          padding: 0.12rem 0.16rem;
          border: none;
          outline: none;
          height: 100%;
        }
      }
      .input_send {
        background: #02a8a2;
        border-radius: 0px 4px 4px 0px;
        color: #fff;
        width: 0.6rem;
        height: 0.48rem;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.48rem;
        cursor: pointer;
      }
    }
  }
}
</style>
